import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import {Button, rem} from '@mantine/core';
import {IconArrowRight} from '@tabler/icons-react';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function JobDetails() {
  useDocumentTitle('Vacancies-Quality-Home-Healthcare');

  return (
    <div className="body-wrapper">
      <Header />

      <div className="ltn__page-details-area ltn__service-details-area mb-3 pt-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="color-border mb-3"></div>
              <h1 className="text-left compassion mt-5">
                Healthcare Assistant job vacancy
              </h1>
              <h3>Job details</h3>
              <div className="job-box p-5">
                <div className="row mt-3">
                  <div className="col-lg-6 col-md-6">
                    <h6>Job ref</h6>
                    <span className="compassion">ERT345</span>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <h6>Pay rate</h6>
                    <span className="compassion">#14.00</span>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-6 col-md-6">
                    {' '}
                    <h6>Location</h6>
                    <span className="compassion">Tamworth, West Midlands</span>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <h6>Work Patterns</h6>
                    <span className="compassion">
                      Full Time, Part Time, Days, Mondays, Tuesdays, Wednesdays,
                      Thursdays, Fridays, Saturdays, Sundays,
                    </span>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-6 col-md-6">
                    <h6>Driver required</h6>
                    <span className="compassion">No</span>
                  </div>
                  <div className="col-lg-6 col-md-6"></div>
                </div>
                <div className="row mt-4">
                  <div className="col-lg-6">
                    <Button
                      size="lg"
                      component="a"
                      href="/job-apply"
                      rel="noopener noreferrer"
                      rightIcon={<IconArrowRight size={rem(18)} />}
                      styles={theme => ({
                        root: {
                          backgroundColor: '#21485e',
                          border: 0,

                          '&:not([data-disabled])': theme.fn.hover({
                            backgroundColor: '#21485e',
                            color: '#ffffff',
                          }),
                        },

                        rightIcon: {
                          marginRight: theme.spacing.md,
                        },
                      })}
                    >
                      Apply for this job
                    </Button>
                  </div>
                </div>
              </div>
              <h3 className="mt-4">Job description</h3>
              <p>
                We are looking for committed and experienced Healthcare
                Assistants in Tamworth to support our service user with his
                complex care needs.
              </p>
              <p>
                If you are a dedicated and passionate healthcare professional,
                who can create a friendly yet professional environment, and
                enjoys delivering one-to-one support, we need you! You will be
                able to build strong, long-lasting bonds with our service users
                and their families while providing and upholding the high
                standard of home healthcare that Apollo Home Healthcare is known
                for.
              </p>
              <p>
                Our service user is in his early 30's and lives with his family
                in Tamworth, who requires care on a 1:1 basis throughout the day
                & night.
              </p>
              <p>
                At home he likes to spend time watching films, he is a big fan
                of all Star Wars movies.
              </p>
              <p>
                During the day he enjoys accessing the community such as going
                for breakfast and meals with his family. In the summer he loves
                to attend to music festivals.
              </p>
              <p>
                He also enjoys music, particularly heavy metal music and loves
                going out to live gigs.
              </p>
              <p>
                We work hard to build close relationships with our service users
                and their families as we understand the importance that we play
                in their lives.
              </p>
              <h3>Essential Experience Required</h3>
              <div>
                <ul className="care_bullets-2">
                  <li>3 months' previous care experience</li>
                  <li>Medication Administration</li>
                  <li>Personal Care</li>
                  <li>Moving and Handling</li>
                </ul>
              </div>
              <h3>Desirable Experience</h3>
              <div>
                <ul className="care_bullets-2">
                  <li>Knowledge of Spinal Muscular Atrophy</li>
                  <li>Ventilation Management</li>
                  <li>Cough Assist</li>
                  <li>UK Driving Licence</li>
                </ul>
              </div>
              <h3>Shifts Available</h3>
              <div>
                <ul className="care_bullets-2">
                  <li>Full Time / Part Time</li>
                  <li>Days 8am-8pm</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/care">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        Complex care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8"></div>
          </div>
        </div>
      </div>

      <CallToAction />
      <Footer />
    </div>
  );
}

export default JobDetails;
